"use strict";var getEnvironDomain=require("../getEnvironDomain-4b2eecf2.js");module.exports=getEnvironDomain.getEnvironDomain;
